import * as tslib_1 from "tslib";
import { ErrorBase } from "@awayjs/core";
import { TraverserBase, SamplerCube } from "@awayjs/graphics";
import { BoundsType } from "../bounds/BoundsType";
import { LightBase } from "./LightBase";
var LightProbe = (function (_super) {
    tslib_1.__extends(LightProbe, _super);
    function LightProbe(diffuseMap, specularMap) {
        if (specularMap === void 0) { specularMap = null; }
        var _this = _super.call(this) || this;
        _this.diffuseSampler = new SamplerCube();
        _this.specularSampler = new SamplerCube();
        _this._pIsEntity = true;
        _this.diffuseMap = diffuseMap;
        _this.specularMap = specularMap;
        //default bounds type
        _this._boundsType = BoundsType.NULL;
        return _this;
    }
    Object.defineProperty(LightProbe.prototype, "traverseName", {
        get: function () {
            return LightProbe.traverseName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LightProbe.prototype, "assetType", {
        get: function () {
            return LightProbe.assetType;
        },
        enumerable: true,
        configurable: true
    });
    //@override
    LightProbe.prototype.iGetObjectProjectionMatrix = function (entity, cameraTransform, target) {
        if (target === void 0) { target = null; }
        throw new ErrorBase("Object projection matrices are not supported for LightProbe objects!");
    };
    return LightProbe;
}(LightBase));
export { LightProbe };
LightProbe.traverseName = TraverserBase.addEntityName("applyLightProbe");
LightProbe.assetType = "[light LightProbe]";



// WEBPACK FOOTER //
// ../dist/lib/display/LightProbe.js